import React, { useId } from 'react';

/* Знак Balancify — два полукольца со сдвигом (обмен X↔Y) на плашке с градиентом бренда.
   Единый исходник формы — brand/mark.js в корне репозитория (оттуда же favicon, иконки
   приложения и заставки); при изменении знака менять синхронно. */
const BrandMark = ({ size = 28, className = '', style }) => {
  const id = `bm-${useId().replace(/:/g, '')}`;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 100 100" style={style} aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#8B6CFF" />
          <stop offset="1" stopColor="#5B3FD6" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="22.37" fill={`url(#${id})`} />
      <g transform="translate(50 50) scale(0.6) translate(-50 -50)" fill="none" stroke="#fff" strokeWidth="11" strokeLinecap="round">
        <path d="M21 46A23 23 0 0 1 67 46" />
        <path d="M79 54A23 23 0 0 1 33 54" />
      </g>
    </svg>
  );
};

export default BrandMark;
